var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputCitySuggest',{ref:this.$root.nameField,attrs:{"required":true,"typeField":'select',"filtered":this.$root.filtered,"placeholder":_vm.placeholder},on:{"change-city":_vm.onChangeCity,"change-country-code":_vm.onChangeCountryCode}})}
var staticRenderFns = []

export { render, staticRenderFns }